import { render, staticRenderFns } from "./case-management.vue?vue&type=template&id=e19645d0&"
import script from "./case-management.vue?vue&type=script&lang=js&"
export * from "./case-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports